// src/pages/MentorsPage.js
import React, { useEffect, useState } from 'react'
import axios from 'axios'

function MentorsPage() {
  const [mentors, setMentors] = useState([])
  const [error, setError] = useState('')

  useEffect(() => {
    const loadMentors = async () => {
      try {
        const res = await axios.get('/mentors', { withCredentials: true })
        setMentors(res.data)
      } catch (err) {
        setError(err.response?.data || 'Fehler beim Laden der Mentoren')
      }
    }
    loadMentors()
  }, [])

  if (error) {
    return <p style={{ color: 'red' }}>{error}</p>
  }

  return (
    <div style={{ padding: '1rem' }}>
      <h2>Mentors</h2>
      {mentors.length === 0 ? (
        <p>Keine Mentoren gefunden.</p>
      ) : (
        <ul>
          {mentors.map(m => (
            <li key={m.id}>
              <strong>{m.email}</strong> <br />
              Role: {m.role} <br />
              Expertise: {m.expertise} <br />
              LinkedIn: {m.linkedin_url} <br />
              <hr />
            </li>
          ))}
        </ul>
      )}
    </div>
  )
}

export default MentorsPage
